.chip {
  display: inline-flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 16px;

  background-color: var(--weak);
  line-height: 1;
  white-space: nowrap;
}
